import React from 'react';
import Hero from '../components/Hero';
import ProgramsTestimonials from '../components/ProgramsTestimonials';

const Home = () => {
  return (
    <>
      <Hero />
      <ProgramsTestimonials />
    </>
  );
};

export default Home;
